// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productGridContainerStyle } from "@ces/App/Components/Product/ProductGridContainer";
import { color, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

productGridContainerStyle.container = {
    css: css`
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        max-width: 317px;
        width: 100%;
        border: 1px solid ${color("common.ui4")};
        border-radius: 2px;
        background-color: ${color("common.ui1")};
        box-shadow: none;
        box-sizing: border-box;
        padding: 9px;
        ${xScreen("lte", "md")} {
            border: initial;
        }
        ${xScreen("lte", "sm")} {
            margin: 0 auto;
        }
        ${xScreen("lte", "xs")} {
            max-width: 100%;
        }

        & > .top-section {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            ${xScreen("lte", "md")} {
                flex-direction: row;
                column-gap: 12px;
            }

            & > .image-section {
                margin-bottom: 8px;

                &:empty {
                    display: none;
                }

                ${xScreen("lte", "md")} {
                    margin-bottom: 0;
                }
            }
            & > .info-section {
                display: flex;
                flex-direction: column;
                flex-grow: 1;

                &:empty {
                    display: none;
                }
            }
        }
        & > .bottom-section {
            margin-top: auto;
            display: flex;
            flex-direction: column;
            gap: 12px;
        }
    `,
};
productGridContainerStyle.image = {
    css: css`
        position: relative;
        width: 100%;
        height: 301px;
        margin: 0 auto;
        border-radius: 2px;
        ${xScreen("lte", "md")} {
            width: 91px;
            height: 91px;
        }
    `,
};
productGridContainerStyle.info = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
productGridContainerStyle.partNumbersAndBadges = {
    css: css`
        display: flex;
        flex-direction: column;
        margin-bottom: 12px;
        flex-grow: 1;
        justify-content: space-between;
    `,
};
productGridContainerStyle.price = {
    css: css`
        margin-bottom: 4px;
    `,
};
productGridContainerStyle.availability = {
    css: css`
        margin-bottom: 8px;
        &:empty {
            display: none;
        }
    `,
};
productGridContainerStyle.addToCartActions = {
    css: css`
        margin-top: auto;
    `,
};
productGridContainerStyle.addToList = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        &:empty {
            display: none;
        }
    `,
};
productGridContainerStyle.qtyInfo = {
    css: css`
        display: flex;
        flex: 1;
        column-gap: 16px;
        margin-bottom: 8px;
        &:empty {
            display: none;
        }
        ${xScreen("lte", "sm")} {
            margin-bottom: 0;
        }
    `,
};
